var hooks = require("./client/hooks");
exports.default = hooks;
exports.setHeaders = hooks.setHeaders;
exports.setServerUrl = hooks.setServerUrl;
exports.getAPIFrontend = hooks.getAPIFrontend;
exports.getUseAPIFrontend = hooks.getUseAPIFrontend;
